import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { createElement } from "react";
import { publicLoader } from "./loader";
import { apiRunner } from "./api-runner-browser";
import { grabMatchParams } from "./find-path";

// Renders page
let PageRenderer = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(PageRenderer, _React$Component);
  function PageRenderer() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = PageRenderer.prototype;
  _proto.render = function render() {
    const props = _objectSpread(_objectSpread({}, this.props), {}, {
      params: _objectSpread(_objectSpread({}, grabMatchParams(this.props.location.pathname)), this.props.pageResources.json.pageContext.__params),
      pathContext: this.props.pageContext
    });
    const [replacementElement] = apiRunner("replaceComponentRenderer", {
      props: this.props,
      loader: publicLoader
    });
    const pageElement = replacementElement || /*#__PURE__*/createElement(this.props.pageResources.component, _objectSpread(_objectSpread({}, props), {}, {
      key: this.props.path || this.props.pageResources.page.path
    }));
    const wrappedPage = apiRunner("wrapPageElement", {
      element: pageElement,
      props
    }, pageElement, _ref => {
      let {
        result
      } = _ref;
      return {
        element: result,
        props
      };
    }).pop();
    return wrappedPage;
  };
  return PageRenderer;
}(React.Component);
export default PageRenderer;